// An autoreleased past submission owns no snapshot; its content lives at the root of its
// autorelease chain. The API resolves that chain and sends the root questionnaire id as
// snapshot_questionnaire_id. Older payloads without the field fall back to the submission's
// own questionnaire id, which is correct for directly answered submissions.
export const pastSubmissionSnapshotId = (pastSubmission) =>
  pastSubmission?.snapshot_questionnaire_id ?? pastSubmission?.questionnaire_id;
